type Bar = { c: [number, number]; label: string };
type Row = { name: string; kind: string; bars: Bar[] };

const weeks = [16, 23, 30, 7, 14, 21, 28, 4, 11, 18, 25, 1, 8, 15];
const months: [string, number, number][] = [["Nov", 2, 4], ["Dic", 4, 9], ["Ene", 9, 13], ["Feb", 13, 16]];
const context = (): Row => ({ name: "Contexto", kind: "ctx", bars: [{ c: [2, 5], label: "Mini-lanzamiento de Mar" }, { c: [13, 15], label: "Entra marketing" }] });

const scenarios = [
  {
    key: "A", title: "Inicio 16 de noviembre", end: "La estrategia está lista cuando entra marketing.",
    phases: [["Escucha", "16 al 27 de noviembre", "b1"], ["Esencia", "30 de noviembre al 18 de diciembre", "b2"], ["Pausa", "21 de diciembre al 1 de enero", "bp"], ["Dirección", "4 al 22 de enero", "b3"], ["Transferencia", "25 de enero al 5 de febrero", "b4"]],
    rows: [
      { name: "Escucha", kind: "b1", bars: [{ c: [2, 4], label: "2 sem" }] },
      { name: "Esencia", kind: "b2", bars: [{ c: [4, 7], label: "3 sem" }] },
      { name: "Pausa", kind: "bp", bars: [{ c: [7, 9], label: "Fiestas" }] },
      { name: "Dirección", kind: "b3", bars: [{ c: [9, 12], label: "3 sem" }] },
      { name: "Transferencia", kind: "b4", bars: [{ c: [12, 14], label: "2 sem" }] },
      context(),
    ] as Row[],
  },
  {
    key: "B", title: "Inicio 1 de diciembre", end: "Marketing se suma durante la Transferencia.",
    phases: [["Escucha", "1 al 11 de diciembre", "b1"], ["Esencia", "14 al 18 de diciembre y 4 al 15 de enero", "b2"], ["Pausa", "21 de diciembre al 1 de enero", "bp"], ["Dirección", "18 de enero al 5 de febrero", "b3"], ["Transferencia", "8 al 19 de febrero", "b4"]],
    rows: [
      { name: "Escucha", kind: "b1", bars: [{ c: [4, 6], label: "2 sem" }] },
      { name: "Esencia", kind: "b2", bars: [{ c: [6, 7], label: "1 sem" }, { c: [9, 11], label: "2 sem" }] },
      { name: "Pausa", kind: "bp", bars: [{ c: [7, 9], label: "Fiestas" }] },
      { name: "Dirección", kind: "b3", bars: [{ c: [11, 14], label: "3 sem" }] },
      { name: "Transferencia", kind: "b4", bars: [{ c: [14, 16], label: "2 sem" }] },
      context(),
    ] as Row[],
  },
];

const legend = [["b1", "Escucha"], ["b2", "Esencia"], ["b3", "Dirección"], ["b4", "Transferencia"], ["bp", "Pausa"], ["bm", "Entrada estimada de marketing"]];

export default function MarCalendar() {
  return (
    <section className="band day" id="calendario"><div className="wrap">
      <div className="head"><p className="eyebrow">07 · Calendario de referencia</p><h2>Dos escenarios posibles para arrancar</h2><p className="lede">Las fechas son tentativas y sirven para ilustrar el desarrollo. Las ajustamos teniendi en cuenta tu agenda, tus lanzamientos y la pausa de fin de año.</p></div>

      <div className="mcal-cards">{scenarios.map(sc => (
        <article className="mcal-card" key={sc.key}>
          <header><span className="mcal-letter">{sc.key}</span><div><p className="tag">Escenario {sc.key}</p><h3>{sc.title}</h3></div></header>
          <ol className="mcal-steps">{sc.phases.map(([n, d, k]) => <li key={n}><i aria-hidden="true" className={k} /><strong>{n}</strong><span>{d}</span></li>)}</ol>
          <p className="mcal-end"><strong>Cierre</strong> {sc.end}</p>
        </article>))}
      </div>

      <p className="mcal-note">Cronograma tentativo por semana · cada columna es una semana, empezando el lunes indicado.</p>
      {scenarios.map(sc => (
        <div className="mcal-gantt-block" key={sc.key}>
          <p className="tier-label">Escenario {sc.key} · {sc.title.toLowerCase()}</p>
          <div className="mcal-scroll" role="region" tabIndex={0} aria-label={`Diagrama de Gantt del escenario ${sc.key}`}>
            <div className="mcal-gantt">
              {months.map(([m, a, b]) => <div className="gm" key={m} style={{ gridRow: 1, gridColumn: `${a}/${b}` }}>{m}</div>)}
              {weeks.map((w, i) => <div className="gw" key={i} style={{ gridRow: 2, gridColumn: i + 2 }}>{w}</div>)}
              {sc.rows.map((r, ri) => [
                <div className={`gl${r.kind === "bp" || r.kind === "ctx" ? " soft" : ""}`} key={`l${ri}`} style={{ gridRow: ri + 3 }}>{r.name}</div>,
                <div className="gtrack" key={`t${ri}`} style={{ gridRow: ri + 3, gridColumn: "2/16" }} />,
                ...r.bars.map((b, bi) => <div key={`b${ri}${bi}`} className={`gb ${r.kind === "ctx" ? (bi ? "bm" : "bc") : r.kind}`} style={{ gridRow: ri + 3, gridColumn: `${b.c[0]}/${b.c[1]}` }}>{b.label}</div>),
              ])}
            </div>
          </div>
        </div>
      ))}
      <div className="mcal-legend">{legend.map(([k, l]) => <span key={k}><i className={k} />{l}</span>)}</div>
    </div></section>
  );
}
